export const workflowBuildingBlockRegistry = {};
export const workflowCardRegistry = {};
export const workflowPageRegistry = {};
export const workflowModalRegistry = {};
